import {LitElement, html} from 'lit';
import {customElement, property} from 'lit/decorators.js';
//import { __ } from '@wordpress/i18n';

@customElement( 'custom-toggle' )
export class CustomToggle extends LitElement {

  @property( { attribute: 'ids-element-id' } )
  elementId: string;

  @property( { attribute: 'ids-label' } )
  label: string;

  @property( { attribute: 'ids-value' } )
  value: string;

  @property( { attribute: 'ids-checked', type: Boolean } )
  checked: boolean = false;

  createRenderRoot() {
    return this;
  }

  render() {
    return html`
      <label class="inline-flex relative items-center cursor-pointer">
        <input type="checkbox" value="${ this.value }" class="sr-only peer" ?checked="${ this.checked }">
        <div class="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
        <span class="ml-3 text-sm text-gray-900 dark:text-gray-300">${ this.label }</span>
      </label>
    `;
  }
}
